import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, IconButton, withStyles, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import FAQAccordion from './FAQAccordion';
import { Typography } from '@mui/material';

const styles = (theme) => ({
  dialogRoot: {
    '& .MuiDialog-paper': {
      height: '80vh',
    },
    '& .MuiDialog-container': {
      // height: '110%',
    },
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
      },
    },
  },
  dialogTitle: {
    margin: '0',
    padding: theme.spacing(2),
  },
  dialogTitleContent: {
    textAlign: 'center',
    fontSize: '19.5px',
    fontWeight: 'bold',
    color: theme.palette.primary.point,
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  closeBtn: {
    // right: '12px',
    // top: '4px',
    color: '#5b5b5b',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
});

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      faqList: [],
      matches: window.matchMedia('(max-width:960px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { classes, open, onClose } = this.props;

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={onClose}
          aria-labelledby="faq-dialog-title"
          open={open}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Grid container justifyContent="center" alignContent="center">
              <Grid container item xs={1} />
              <Grid container justifyContent="center" alignContent="center" item xs={10}>
                <Grid
                  style={{
                    backgroundColor: this.props.theme.palette.primary.main,
                    borderRadius: this.state.matches ? '15px' : '30px',
                    padding: this.state.matches ? '8px 4vw' : '8px 8vw',
                  }}
                >
                  <Typography
                    style={{
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: this.state.matches ? '18px' : '22px',
                      lineHeight: this.state.matches ? 1 : '',
                    }}
                  >
                    Information Desk
                  </Typography>
                </Grid>
              </Grid>

              <Grid container justifyContent="center" alignContent="center" item xs={1}>
                <IconButton
                  onClick={onClose}
                  className={classes.closeBtn}
                  // style={{ position: 'absolute' }}
                >
                  <CloseIcon size={30} />
                </IconButton>
              </Grid>
            </Grid>

            {/* <div className={classes.dialogTitleContent}>
              <span>Information Desk</span>
              <IconButton onClick={onClose} className={classes.closeBtn} style={{ position: 'absolute' }}>
                <CloseIcon />
              </IconButton>
            </div> */}
          </DialogTitle>
          <DialogContent
            style={
              {
                // borderTop: '2px solid #035a3c'
              }
            }
          >
            <FAQAccordion />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <div style={{ borderTop: '1px solid rgba(0, 0, 0, 0.2)' }}>
              <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
                {/* 닫기 */}
                Close
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FAQ);
